module.exports = __webpack_public_path__ + "img/new-03-thumbfly3.de675450.jpg";